import { all } from 'redux-saga/effects'

import resetState from './resetState'
import rotatePageSaga from './rotatePageSaga'

function* playerToolbarSaga() {
  yield all([resetState(), rotatePageSaga()])
}

export default playerToolbarSaga
